import { render } from "./CompanyMember.vue?vue&type=template&id=a3e3ae44"
import script from "./CompanyMember.vue?vue&type=script&lang=js"
export * from "./CompanyMember.vue?vue&type=script&lang=js"
script.render = render

export default script